import React from 'react';
import { LinkButton, StyledLink, StyledSpan } from './FormattedLink.styles';

export type FormattedLinkProps = {
  href: string;
  icon?: React.ReactNode;
  format?: 'button' | 'link';
  children?: React.ReactNode;
  isPrimary?: boolean;
};

export const FormattedLink: React.FC<FormattedLinkProps> = ({
  isPrimary,
  children,
  format = 'link',
  href,
}) => {
  return (
    <>
      {format === 'button' ? (
        <LinkButton tagName="a" href={href} isPrimary={isPrimary}>
          <StyledSpan>{children}</StyledSpan>
        </LinkButton>
      ) : (
        <StyledLink route={href}>
          <StyledSpan>{children}</StyledSpan>
        </StyledLink>
      )}
    </>
  );
};
